import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Category } from '@/types/database';

export function useCategories() {
  return useQuery({
    queryKey: ['categories'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('categories')
        .select('*, classes(count)')
        .order('name');

      if (error) throw error;
      
      // Sort by class count descending so categories with the most classes appear first
      const sorted = (data as any[]).sort((a, b) => {
        const countA = a.classes?.[0]?.count ?? 0;
        const countB = b.classes?.[0]?.count ?? 0;
        return countB - countA;
      });

      return sorted as Category[];
    },
  });
}
